import React from 'react'
import ReceivedPersonsToggle from './ReceivedPersonsToggle'
import { CompanyReceivedPersons } from '../../../interfaces/kuvaweb'
import { t } from 'i18next'

type Props = {
  options: Array<CompanyReceivedPersons> | null
  value: string
  onChange: (value: string) => void
  selectedReceivedPerson: CompanyReceivedPersons | null
}

const ReceivedPersonsBlock: React.FC<Props> = props => {
  const { onChange, options, value, selectedReceivedPerson } = props

  if (!options || options.length === 0) {
    return null
  }

  return (
    <div className="received-person-block">
      <div className="info-field">
        <div className="label">
          {selectedReceivedPerson
            ? t('cashout.selectedReceivedPersonsToggleLabel')
            : t('cashout.receivedPersonsToggleLabel')}
        </div>
        {selectedReceivedPerson && (
          <div className="info">
            <p>
              {selectedReceivedPerson.firstName}{' '}
              {selectedReceivedPerson.lastName}
            </p>
            <p>{selectedReceivedPerson.idNumber}</p>
          </div>
        )}
      </div>

      {!selectedReceivedPerson && (
        <ReceivedPersonsToggle
          onChange={onChange}
          options={options}
          value={value}
        />
      )}
    </div>
  )
}

export default ReceivedPersonsBlock
